import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import { getGroupInvitation } from "../../utilities/api";
import { GroupManageWrapper } from "../../components";

export default function GroupManagePage() {
  let { groupCode } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  const getInvite = () => {
    getGroupInvitation(groupCode)
      .then((res) => {
        setData(res?.data.data[0]?.attributes);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (groupCode) getInvite();
  }, []);

  return (
    <>
      {loading && <h4>Loading ...</h4>}
      {!loading && <GroupManageWrapper data={data} />}
    </>
  );
}
